import React, { FC, useCallback, useEffect, useState } from 'react';
import withStyles from 'src/common/withStyles';

import { decorateComponent, getClassNameFor } from '../../../common/helpers';
import { useResizeObserver } from '../../../common/hooks';
import s from './CTA.module.scss';

const PINNED_CLASS_NAME = 'with-pinned-CTA';
const WARNING_CLASS_NAME = 'with-warning';

// Checks whether the body height is greater than the viewport height
const doesPageFitInViewport = () => document.body.clientHeight <= window.innerHeight;

type Props = {
  classNameModifier?: string;
  withWarning?: boolean;
};

const CTA: FC<Props> = ({ children, classNameModifier = '', withWarning }) => {
  const permanentlyPinned = classNameModifier.includes('pinned');
  const [pinned, setPinned] = useState(() => permanentlyPinned || !doesPageFitInViewport());
  const updatePinnedState = useCallback(() => {
    if (!permanentlyPinned) {
      setPinned(!doesPageFitInViewport());
    }
  }, [permanentlyPinned]);

  useEffect(() => {
    document.body.classList.toggle(PINNED_CLASS_NAME, pinned);
    if (withWarning) {
      document.body.classList.toggle(WARNING_CLASS_NAME, pinned);
    }
    return () => {
      document.body.classList.remove(PINNED_CLASS_NAME);
      document.body.classList.remove(WARNING_CLASS_NAME);
    };
  }, [pinned, withWarning]);

  useResizeObserver(document.body, updatePinnedState);

  const modifiers = [classNameModifier, pinned ? 'pinned' : 'unpinned'].join(' ');

  return (
    <div className={getClassNameFor(s, 'root', modifiers)}>
      <div className={getClassNameFor(s, 'wrapper', modifiers)}>{children}</div>
    </div>
  );
};

const decorators = [withStyles(s)];

export { CTALink, CTAButton, CTAExternalLink, CTABackLink } from './elements';
export default decorateComponent(CTA, decorators);
